<template>
  <Line
    :id="id"
    :data="chartData"
    :options="chartOptions"
  />
</template>
<script setup lang="ts">
  import type { ChartData, ChartOptions } from 'chart.js';
  import {
    CategoryScale,
    Chart as ChartJS,
    Filler,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
  } from 'chart.js';
  import { ref } from 'vue';
  import { Line } from 'vue-chartjs';

  ChartJS.register(
    CategoryScale,
    Filler,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    Title,
    Tooltip,
  );

  const props = defineProps({
    data: {
      type: Object as () => ChartData<'line'>,
      required: true,
    },
    options: {
      type: Object as () => ChartOptions<'line'>,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  });

  const chartData = ref<ChartData<'line'>>(props.data);

  const chartOptions = ref<ChartOptions<'line'>>(props.options);
</script>
